import { Injectable } from '@angular/core';
import { EnvironmentConfiguration } from './environment.configuration';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {

  constructor(private readonly environment: EnvironmentConfiguration) { }

  private readonly featureFlags = this.environment.FEATURE_FLAGS;

    isFeatureEnabled(featureName: string): boolean {
        return this.featureFlags?.[featureName];
    }

}
